module.exports = __webpack_public_path__ + "img/cover.9a21c01e.jpg";